import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const paymentMethodSchemaLiteral = {
  title: 'payment_method',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 50 },
    type: { type: 'string', enum: ['local', 'foreign'], maxLength: 10 },
    currency: { type: 'string', maxLength: 5 },
    is_active: { type: 'boolean' },
    branch_id: { type: ['string', 'null'], maxLength: 100 },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'name', 'type', 'currency', 'updated_at', 'is_deleted', 'is_active'],
  indexes: ['is_deleted', 'type', 'updated_at'],
} as const;

const schemaTyped = toTypedRxJsonSchema(paymentMethodSchemaLiteral);
export type PaymentMethodDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const paymentMethodSchema: RxJsonSchema<PaymentMethodDocType> = paymentMethodSchemaLiteral;
